var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_948_7445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 7.38668V8.00001C14.6665 9.43763 14.201 10.8365 13.3402 11.9879C12.4794 13.1393 11.2695 13.9817 9.89089 14.3893C8.51227 14.7969 7.03882 14.7479 5.6903 14.2497C4.34177 13.7515 3.19042 12.8307 2.40796 11.6247C1.6255 10.4187 1.25385 8.99205 1.34844 7.55755C1.44303 6.12305 1.99879 4.75756 2.93284 3.66473C3.86689 2.57189 5.12917 1.81027 6.53144 1.49344C7.93371 1.17662 9.40083 1.32157 10.714 1.90668",
    stroke: "#2E296C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.66666L8 9.33999L6 7.33999",
    stroke: "#2E296C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_948_7445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListTick);
export default __webpack_public_path__ + "static/media/listTick.544ead5ff7fcda614d1ce9753234c30e.svg";
export { ForwardRef as ReactComponent };